import { render, staticRenderFns } from "./VehicleReadOnlyInfo.vue?vue&type=template&id=d4140d54&scoped=true"
import script from "./VehicleReadOnlyInfo.vue?vue&type=script&lang=js"
export * from "./VehicleReadOnlyInfo.vue?vue&type=script&lang=js"
import style0 from "./VehicleReadOnlyInfo.vue?vue&type=style&index=0&id=d4140d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4140d54",
  null
  
)

export default component.exports